// 公用方法
export default {
  data() {
    return {
      over: false, //是否停留
      timer: null,
      headList: [] //表头
    };
  },
  methods: {
    // 打开配置弹窗 jumpYz是否跳过团险验证
    openConfigModal(name, jumpYz) {
      if (!jumpYz && (this.topItem.sourceType != 2 || this.topItem.productCategory != 3)) {
        return;
      }
      if(!this.$units.pointAction('pro_7_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      this.$emit('openModal', { name: name, data: this.$props });
      window.setTimeout(() => {
        this.closePreview();
      }, 500);
    },
    // 打开预览
    closePreview() {
      this.visible = false;
      this.over = false;
      window.clearTimeout(this.timer);
    },
    // 关闭预览 jumpYz是否跳过团险验证
    openPreview(jumpYz) {
      this.over = true;
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => {
        // 商户自己的团险暂不可配置
        if (!jumpYz && (this.topItem.sourceType == 2 && this.topItem.productCategory != 3)) {
          if (this.over) {
            this.visible = true;
          }
          return;
        }
        this.initData();
      }, 300);
    },
    // 费用输入
    inputChange(data, curValue, key = 'commission') {
      let sum = 100;
      if (isNaN(curValue)) {
        curValue = 0;
      } else if (curValue.indexOf('.') == curValue.length - 1 && (key == 'commission' || key == 'coefficient')) {
        //末位小数点不处理
        return;
      } else {
        curValue = curValue * 1;
      }
      curValue = Math.floor(curValue.mul(100)).div(100); //舍弃多余位数
      if (curValue > sum) {
        curValue = sum;
      } else if (curValue < 0) {
        curValue = '0';
      }
      this.$nextTick(() => {
        this.$set(data, key, curValue);
      });
    },
    // 获取当前险种是否可配置数据
    getStatus() {
      return this.$http({
        url: '/buz/upcommission/judgeCommissionIsNull',
        type: 'POST',
        data: this.tableItem
      }).then(res => {
        return res.data;
      });
    },
    // 获取当前产品是否可配置数据
    getStatusAll() {
      return this.$http({
        url: '/buz/upcommission/judgeProductCommissionIsNotNull',
        type: 'POST',
        data: this.topItem.commissionItems
      }).then(res => {
        return res.data;
      });
    },
    // 打开费用配置弹窗
    openBaseModal() {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '请先配置基础费用！',
          okText: '去配置'
        })
        .then(() => {
          this.$emit('openModal', {
            name: 'baseCommissionModal',
            data:this.topItem
          });
        });
    },
    // 获取费用方案表头信息
    getPlanInfo() {
      return this.$http({
        url: '/buz/upcommission/getProgramRules',
        type: 'GET',
        data: {
          productCode: this.topItem.productCode
        }
      }).then(res => {
        const data = res.data.gradeList.find(item => item.gradeCode == this.tableItem.gradeCode);
        this.headList = data.programRules&&data.programRules;
      });
    }
  }
};
